import { LitElement, html, css, unsafeCSS } from "lit-element";

import broadcastLiveStatsTeamsStyles from "./broadcast-live-stats-teams.scss";

import { MetricMatchModel } from "../../../models/broadcast/metricMatchModel";
import Consts from "../../../consts/consts";
import { BroadcastTemplateModel } from "../../../models/broadcast/broadcastTemplateModel";
import BroadcastMetricTypes from "../../../enums/broadcast-metric-type";
import { MetricModel } from "../../../models/broadcast/metricModel";
import CardComponentType from "../../../enums/card-component-type";
import NumberComparisonTable from "./number-comparison-table";
import HorizontalBarMeter from "./horizontal-bar-meter";

export default class BroadcastLiveStatsTeams extends LitElement {
    private _match: MetricMatchModel;
    private _templates: BroadcastTemplateModel[];
    private _homeTeamColour: string;
    private _awayTeamColour: string;

    constructor(
        match: MetricMatchModel,
        templates: BroadcastTemplateModel[],
        homeTeamColour: string,
        awayTeamColour: string) {
        super();

        this._match = match;
        this._templates = templates;

        this._homeTeamColour = homeTeamColour;
        this._awayTeamColour = awayTeamColour;
    }

    async firstUpdated() {

        this._templates.filter(x => x.broadcastMetricType === BroadcastMetricTypes.Team).sort((a, b) => this.textSort(a, b, 'order'));
        this._templates.map((value) => {
            value.templateItems.sort((a, b) => this.textSort(a, b, 'order'));
        });
    }

    textSort(a, b, property) {
        let aProp = a ? a[property] : 0;
        let bProp = b ? b[property] : 0;

        let returnValue = 0;

        if (aProp < bProp)
            returnValue = -1;
        else
            returnValue = 1;

        return returnValue;
    }

    renderTeams(template: BroadcastTemplateModel) {
        return html`

        <div class="stats-container">

            <h5>${template.name}</h5>

            <div class="components">

            ${template.templateItems.map((templateItem) => {

                let homeMetric: MetricModel = this._match.teams[0].metrics.find(x => x.metricId === templateItem.broadcastMetricId);
                let awayMetric: MetricModel = this._match.teams[1].metrics.find(x => x.metricId === templateItem.broadcastMetricId);
    
                switch (template.componentType) {
                    case CardComponentType.HorizontalBarMeterMiddleStart: 
                        return html`${new HorizontalBarMeter(homeMetric, awayMetric, templateItem, this._homeTeamColour, this._awayTeamColour)}`;
                        break;
                    case CardComponentType.NumberComparisonTable: 
                        return html`${new NumberComparisonTable(homeMetric, awayMetric, templateItem, this._homeTeamColour, this._awayTeamColour)}`;
                    case CardComponentType.PlayerBreakdownTable: 
                        break;
                    default: 
                        return html``;
                }
            })}
            </div>          
        </div>`;
    }

    createRenderRoot() {
        return this;
    }

    render() {
        return [
            html`
            <style>
                ${css`${unsafeCSS(broadcastLiveStatsTeamsStyles)}`}                     
            </style>

            ${(this._match && this._match.teams.length > 0) ? html`${this._templates.map((template) => template.broadcastMetricType === BroadcastMetricTypes.Team ? this.renderTeams(template) : '')}` : ''}`
        ];
    }
}

window.customElements.define('broadcast-live-stats-teams', BroadcastLiveStatsTeams as any);